import { render } from "./OAuthError.vue?vue&type=template&id=48e29680"
import script from "./OAuthError.vue?vue&type=script&lang=js"
export * from "./OAuthError.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__